import React from "react";
import sendEddData from "../../handlers/sendEddData";
import submitEddData from "../../handlers/submitEddData";
import { Event } from "../../types/event.types";
import { sendPostMessage } from "../../utils/postMessage";
import Button from "../ui/Button/Button";

interface Props {
  enableSubmitButton: boolean;
  uploadedDocuments: any[];
  setUploadedDocuments: React.Dispatch<React.SetStateAction<any[]>>;
  enabledSectionsCount: number;
  isSendingEddData: boolean;
  formProgress: number;
  isSubmittingEddData: boolean;
  setIsSubmittingEddData: React.Dispatch<React.SetStateAction<boolean>>;
  onSubmissionSuccess: () => void;
  onError: (message: string) => void;
}

const Footer: React.FC<Props> = ({
  enableSubmitButton,
  uploadedDocuments,
  setUploadedDocuments,
  isSendingEddData,
  formProgress,
  isSubmittingEddData,
  setIsSubmittingEddData,
  onSubmissionSuccess,
  onError
}) => {
  const handleError = (message: string) => {
    sendPostMessage({
      status: Event.ERROR,
      message: message
    });
    onError(message);
  };

  const handleSubmitEddData = async () => {
    setIsSubmittingEddData(true);
    let sendEddResponse = { success: true, errors: [{ text: "" }] };
    if (uploadedDocuments.length) {
      sendEddResponse = await sendEddData({
        section: "DOCUMENT",
        question: "DOCUMENT",
        files: uploadedDocuments.map(({ document_tag, encoded_string }) => ({
          document_tag,
          encoded_string
        }))
      });
    }
    if (sendEddResponse?.success) {
      setUploadedDocuments([]);
      const submitEddResponse = await submitEddData();
      setIsSubmittingEddData(false);
      if (submitEddResponse?.success) {
        sendPostMessage({
          status: Event.COMPLETED,
          message: "Data submitted successfully"
        });
        onSubmissionSuccess();
      } else {
        handleError(submitEddResponse?.errors?.[0]?.text);
      }
    } else {
      setIsSubmittingEddData(false);
      handleError(sendEddResponse?.errors?.[0]?.text);
    }
  };

  return (
    <footer className="bg-white border-t shadow-sm py-4 px-5 fixed bottom-0 left-0 w-full z-50">
      <div className="flex items-center justify-center max-w-md mx-auto px-4">
        {!isSubmittingEddData && (
          <img
            src="https://images.mudrex.com/app/misc/security-extended.png"
            className="w-6 h-6 mr-[10px]"
            alt="Security icon"
          />
        )}
        <p className="text-sm text-gray-600 text-center">
          {isSubmittingEddData
            ? "Document submission may take up to 30 seconds. Please don't close the app or go back."
            : `Your data is securely stored${
                isSendingEddData
                  ? " • Saving.."
                  : formProgress > 0
                    ? " • Saved"
                    : ""
              }`}
        </p>
      </div>
      <Button
        id="submit-btn"
        type="primary"
        className="w-full mt-4"
        disabled={!enableSubmitButton}
        onClick={handleSubmitEddData}
        loading={isSubmittingEddData}
      >
        Submit Details and Continue
      </Button>
    </footer>
  );
};

export default Footer;
